import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

export const fetchImageList = createAxiosThunk(
  'image/fetchImageList',
  (noArgs, { getState }) => {
    const { imageSize, page, size } = getState().image.imageList
    return api.image.searchDspImages({
      sizeTypes: imageSize ? [imageSize] : [],
      page,
      size,
    })
  }
)

export const deleteImageList = createAxiosThunk(
  'image/deleteImageList',
  imageIds => api.image.deleteDspImages(imageIds)
)

const initialState = {
  isLoading: false,
  imageSize: null,
  content: [],
  totalElements: 0,
  page: 0,
  size: 20,
}

const imageListSlice = createSlice({
  name: 'image/imageList',
  initialState,

  reducers: {
    setImageSize: (state, { payload }) => {
      state.imageSize = payload
    },
    setPage: (state, { payload: page }) => {
      state.page = page
    },
    setSize: (state, { payload: size }) => {
      state.size = size
    },
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchImageList.pending, state => {
      state.isLoading = true
    })

    builder.addCase(fetchImageList.rejected, state => {
      state.content = []
      state.totalElements = 0
      state.isLoading = false
    })

    builder.addCase(fetchImageList.fulfilled, (state, { payload }) => {
      state.content = payload.dspImageDtos
      state.totalElements = payload.totalElements
      state.isLoading = false
    })

    builder.addCase(deleteImageList.pending, state => {
      state.isLoading = true
    })

    builder.addCase(deleteImageList.rejected, state => {
      state.isLoading = false
    })

    builder.addCase(deleteImageList.fulfilled, state => {
      state.isLoading = false
    })
  },
})

const { actions, reducer } = imageListSlice
export const { setImageSize, setPage, setSize, reset } = actions
export default reducer
